webpackJsonp([22,47],{

/***/ 1267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FeedbackComponent_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FeedbackComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_FeedbackComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_KendoTable__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_KendoTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_KendoTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SiteFooter_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SiteFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_SiteFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var db = __WEBPACK_IMPORTED_MODULE_5_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    FeedbackComponent: __WEBPACK_IMPORTED_MODULE_3__components_FeedbackComponent_vue___default.a,
    KendoTable: __WEBPACK_IMPORTED_MODULE_4__components_KendoTable___default.a,
    SiteFooter: __WEBPACK_IMPORTED_MODULE_7__components_SiteFooter_vue___default.a
  },
  data: function data() {
    return {
      favoritedItems: [],
      link: 'https://fed-exchange-api.herokuapp.com/api/v2.0/',
      dialog: false,
      recordsCount: 0,
      totalItems: 0,
      selectedRow: '',
      items: [],
      item: null,
      count: 0,
      search: '',
      companies: [],
      contracthistory: [],
      events: [],
      resources: [],
      groups: [],
      loading: false,
      tableHeader: [{
        text: 'Title',
        align: 'left',
        sortable: false,
        value: 'title'
      }, {
        text: 'Action',
        align: 'left',
        sortable: false,
        value: 'link'
      }],
      historyHeader: [{
        text: 'Vendor',
        align: 'left',
        sortable: false,
        value: 'title'
      }, {
        text: 'Action',
        align: 'left',
        sortable: false,
        value: 'link'
      }],
      directorySchema: [{
        title: 'Company',
        field: 'companylegalname',
        editable: false
      }, {
        title: 'Address',
        field: 'streetaddress',
        editable: false
      }, {
        title: 'SBA Certifications',
        field: 'companycertifications',
        editable: false
      }],
      historySchema: [{
        title: 'Agency',
        field: 'majagencycat',
        editable: false
      }, {
        title: 'Contract Action Type',
        field: 'contractactiontype',
        editable: false
      }, {
        title: 'NAICS Description',
        field: 'naicsdescription',
        editable: false
      }, {
        title: 'PCS Description',
        field: 'pscdescription',
        editable: false
      }, {
        title: 'Solicitation Procedures',
        field: 'solicitationprocedures',
        editable: false
      }],
      favorited: true,
      directoryUrl: '',
      historyUrl: '',
      contracts: [],
      historyDialog: false,
      seletedHistoryItem: null
    };
  },
  firebase: function firebase() {
    return {
      favoriteDirectory: db.ref('favorites/directory'),
      favoriteHistory: db.ref('favorites/history'),
      favoriteEvents: db.ref('favorites/events')
    };
  },
  computed: {
    pages: function pages() {
      return this.$store.getters.getPages;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    state: function state() {
      if (this.$store.getters.getCompanyDetails) {
        return this.$store.getters.getCompanyDetails.state;
      }
    },
    breakpoint: function breakpoint() {
      return this.$vuetify.breakpoint.name;
    }
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        'h1': 'Favorites',
        'title': 'Favorites',
        'description': 'Favorites Page',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
    this.getCompanies();
    this.getContractHistory();
    this.getEvents();
  },
  methods: {
    getCompanies: function getCompanies() {
      var self = this;
      var userId = this.$store.getters.getUserDetails.uid;
      this.$firebaseRefs.favoriteDirectory.child("/".concat(userId)).once('value', function (result) {
        self.companies = [];

        if (result.val()) {
          self.loading = true;
          var companies = Object.keys(result.val());
          self.directoryUrl = self.link + "exchange-community-v2?_id=".concat(companies.join('.'));
          return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(self.directoryUrl).then(function (res) {
            var comp = res.data.data.map(function (val) {
              return _objectSpread(_objectSpread({}, val), {}, {
                firebaseRef: "favorites/directory/".concat(userId, "/").concat(val._id),
                link: "https://".concat(window.location.host, "/contractors#id=").concat(val._id),
                title: val.companylegalname
              });
            });
            self.loading = false;
            self.companies = comp;
          });
        } else {
          self.loading = false;
        }
      });
    },
    getContractHistory: function getContractHistory() {
      var self = this;
      var userId = this.$store.getters.getUserDetails.uid;
      this.$firebaseRefs.favoriteHistory.child("/".concat(userId)).once('value', function (result) {
        self.contracthistory = [];

        if (result.val()) {
          self.loading = true;
          var historyIds = Object.keys(result.val() || {});
          self.directoryUrl = self.link + "ga-history-v2?id=".concat(historyIds.join(','));
          return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(self.directoryUrl).then(function (res) {
            var comp = res.data.data.map(function (val) {
              return _objectSpread(_objectSpread({}, val), {}, {
                firebaseRef: "favorites/history/".concat(userId, "/").concat(val.id),
                link: "https://".concat(window.location.host, "/contract-history#id=").concat(val.id),
                title: val.recipient_name
              });
            });
            self.loading = false;
            self.contracthistory = comp;
          });
        } else {
          self.loading = false;
        }
      });
    },
    getEvents: function getEvents() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, promises, userId, eventSnap, eventsId, eventsPromises;
        return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _this.loading = true;
                promises = [];
                userId = _this.$store.getters.getUserDetails.uid;
                _context.next = 6;
                return _this.$firebaseRefs.favoriteEvents.child("/".concat(userId)).once('value');

              case 6:
                eventSnap = _context.sent;
                _this.events = [];
                eventsId = Object.keys(eventSnap.val() || {});
                eventsPromises = eventsId.map(function (event) {
                  return self.$firebase.database().ref("/events/".concat(event)).once('value');
                });
                promises = eventsPromises;
                Promise.all(promises).then(function (promise) {
                  promise.forEach(function (eventSnap) {
                    var event = eventSnap.val();
                    event.firebaseRef = "favorites/events/".concat(userId, "/").concat(eventSnap.key);
                    event.link = "https://".concat(window.location.host, "/events#id=").concat(eventSnap.key);
                    self.events.push(event);
                  });
                  self.loading = false;
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    removeFavorite: function removeFavorite(ref) {
      var _this2 = this;

      this.$firebase.database().ref(ref).set(null).then(function (snap) {
        if (ref.indexOf('events') >= 0) {
          _this2.getEvents();
        } else if (ref.indexOf('directory') >= 0) {
          _this2.getCompanies();
        } else if (ref.indexOf('history') >= 0) {
          _this2.getContractHistory();
        }
      });
    },
    selectRow: function selectRow(e) {
      this.selectedRow = e;
    },
    totalRecords: function totalRecords(val) {
      this.recordsCount = val;
    },
    moreInfo: function moreInfo(val) {
      this.dialog = true;
      this.item = val;
    },
    moreInfoHistory: function moreInfoHistory(val) {
      this.historyDialog = true;
      this.selectedHistoryItem = val;
    },
    itemsLoaded: function itemsLoaded(val) {
      // this.removeMarkers()
      this.items = val; // this.loadMarkers()
    },
    cancel: function cancel() {
      this.historyDialog = false;
    }
  }
};

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FavoritesView.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1480:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1391);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("a0ed7dac", content, true, {});

/***/ }),

/***/ 1685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "main-page-body favorites-view",
    staticStyle: {
      "max-width": "1442px",
      "padding-top": "60px"
    },
    style: ({
      backgroundColor: _vm.styles.general.background_color
    })
  }, [_c('div', [_c('v-layout', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v(_vm._s(_vm.pages.favorites.header))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "page-subtitle",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.pages.favorites.sub_text) + "\n            ")])])])], 1), _vm._v(" "), _c('v-layout', [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "primary",
      "grow": _vm.breakpoint === 'xs' || _vm.breakpoint === 'sm'
    }
  }, [_c('v-tab', {
    staticClass: "white",
    staticStyle: {
      "height": "60px",
      "overflow": "none"
    },
    attrs: {
      "light": "",
      "color": "white",
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "font-size": "23px"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("people")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Contractors")]), _vm._v(" (" + _vm._s(_vm.companies.length) + ")\n              ")], 1)]), _vm._v(" "), _c('v-tab', {
    staticClass: "white",
    staticStyle: {
      "height": "60px",
      "overflow": "none"
    },
    attrs: {
      "light": "",
      "color": "white",
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "font-size": "23px"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("people")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Contract History")]), _vm._v(" (" + _vm._s(_vm.contracthistory.length) + ")\n              ")], 1)]), _vm._v(" "), _c('v-tab', {
    staticStyle: {
      "height": "60px",
      "overflow": "none"
    },
    attrs: {
      "light": "",
      "color": "white",
      "href": "#tab-3"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "font-size": "16px"
    }
  }, [_c('v-icon', {
    staticClass: "hidden-md-and-up",
    staticStyle: {
      "font-size": "23px"
    },
    attrs: {
      "medium": ""
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('span', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._v("Events")]), _vm._v(" (" + _vm._s(_vm.events.length) + ")\n              ")], 1)]), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeader,
      "items": _vm.companies,
      "loading": _vm.loading,
      "search": _vm.search,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', [_c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "href": props.item.link,
            "target": "_blank",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('span', [_vm._v("View favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeFavorite(props.item.firebaseRef)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove favorite")])], 1)], 1)])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.historyHeader,
      "items": _vm.contracthistory,
      "loading": _vm.loading,
      "search": _vm.search,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', [_c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "href": props.item.link,
            "target": "_blank",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('span', [_vm._v("View favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeFavorite(props.item.firebaseRef)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove favorite")])], 1)], 1)])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "tab-3"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeader,
      "items": _vm.events,
      "rows-per-page-items": [15, 25, 50, 100],
      "loading": _vm.loading,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-layout', [_c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "href": props.item.link,
            "target": "_blank",
            "icon": ""
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('span', [_vm._v("View favorite")])], 1)], 1), _vm._v(" "), _c('div', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.removeFavorite(props.item.firebaseRef)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove favorite")])], 1)], 1)])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1480)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1267),
  /* template */
  __webpack_require__(1685),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 870:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      competitiveAdvantages: [{
        name: 'Infrastructure',
        link: 'http://www.georgia.org/competitive-advantages/infrastructure/'
      }, {
        name: 'Workforce',
        link: 'http://www.georgia.org/competitive-advantages/training-hiring/'
      }, {
        name: 'Tax Credits',
        link: 'http://www.georgia.org/competitive-advantages/tax-credits/'
      }],
      businessResources: [{
        name: 'Available Buildings Tool',
        link: 'http://www.georgia.org/siteselector/'
      }, {
        name: 'International Trade',
        link: 'http://www.georgia.org/business-resources/international-trade/'
      }, {
        name: 'Small Business & Entrepreneurs',
        link: 'http://www.georgia.org/business-resources/small-business-resource-directory/'
      }],
      industries: [{
        name: 'AeroSpace',
        link: 'http://www.georgia.org/industries/aerospace/'
      }, {
        name: 'Agribusiness',
        link: 'http://www.georgia.org/industries/agribusiness/'
      }, {
        name: 'Arts',
        link: 'http://www.georgia.org/industries/arts/'
      }, {
        name: 'Automotive',
        link: 'http://www.georgia.org/industries/automotive/'
      }, {
        name: 'Contact Center',
        link: 'http://www.georgia.org/industries/contact-centers/'
      }, {
        name: 'Data Center',
        link: 'http://www.georgia.org/industries/data-centers/'
      }, {
        name: 'Defense',
        link: 'http://www.georgia.org/industries/defense/'
      }, {
        name: 'Energy and Environment',
        link: 'http://www.georgia.org/industries/energy-solutions/'
      }, {
        name: 'Entertainment',
        link: 'http://www.georgia.org/industries/entertainment/'
      }, {
        name: 'Headquarters',
        link: 'http://www.georgia.org/industries/headquarters/'
      }, {
        name: 'Fintech',
        link: 'http://www.georgia.org/industries/fintech/'
      }, {
        name: 'Food Processing',
        link: 'http://www.georgia.org/industries/food-processing/'
      }, {
        name: 'Information Technology',
        link: 'http://www.georgia.org/industries/information-technology/'
      }, {
        name: 'Life Sciences',
        link: 'http://www.georgia.org/industries/life-sciences/'
      }, {
        name: 'Logistics and Transportation',
        link: 'http://www.georgia.org/industries/logistics-services/'
      }, {
        name: 'Advanced Manufacturing',
        link: 'http://www.georgia.org/industries/advanced-manufacturing/'
      }, {
        name: 'Tourism',
        link: 'http://www.georgia.org/industries/georgia-tourism/'
      }],
      year: ''
    };
  },
  created: function created() {
    this.year = new Date().getFullYear();
  },
  computed: {
    site_settings: function site_settings() {
      return this.$store.getters.getSettings;
    },
    landing_page: function landing_page() {
      return this.$store.getters.getSettings.pages.landing_pages;
    }
  }
};

/***/ }),

/***/ 872:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "h3[data-v-a9ce9c7e]{font-size:18px;font-family:Roboto;color:#fff;margin-top:5px;margin-bottom:5px}p[data-v-a9ce9c7e]{color:#f5f5f5;font-size:16px;margin-top:5px;margin-bottom:5px}a[data-v-a9ce9c7e]{color:#d5e14d;text-decoration:none;display:block}a[data-v-a9ce9c7e]:hover{color:#28a028}.footer-item[data-v-a9ce9c7e]{font-family:Roboto;background-image:-webkit-gradient(linear,left top,left bottom,from(#5b5b5c),to(#131314));background-image:linear-gradient(#5b5b5c,#131314);width:100%}.footer-bg[data-v-a9ce9c7e]{background:#f3f3f3;height:auto}.before-footer-content[data-v-a9ce9c7e]{height:150px}ul[data-v-a9ce9c7e]{list-style:none}ul li[data-v-a9ce9c7e]{display:inline-block;width:50%}.vertical-divider[data-v-a9ce9c7e]{clear:both;position:relative}.vertical-divider[data-v-a9ce9c7e]:after{clear:both;content:\" \";display:block;height:0;visibility:hidden}.vertical-divider .column[data-v-a9ce9c7e]:not(:first-child):after{background:#6d6d6d;bottom:0;content:\" \";margin-left:-10px;position:absolute;top:0;width:1px}hr .divider[data-v-a9ce9c7e]{background-color:#6d6d6d}.divider-flex-rows[data-v-a9ce9c7e]{width:90%;padding:15px 0;margin:auto}.divider-layout-rows[data-v-a9ce9c7e]{width:100%;padding:15px 0;margin:auto}.footer-copyright[data-v-a9ce9c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.footer-copyright img[data-v-a9ce9c7e]{height:50px;vertical-align:middle}.site-map[data-v-a9ce9c7e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.site-map a[data-v-a9ce9c7e]{margin:0 15px}.site-map img[data-v-a9ce9c7e]{height:50px;vertical-align:middle}.site-map-divider[data-v-a9ce9c7e]{clear:both;position:relative}.site-map-divider[data-v-a9ce9c7e]:after{clear:both;content:\" \";display:block;height:0;visibility:hidden}.site-map-divider .site-map-column[data-v-a9ce9c7e]:not(:first-child):after{background:#6d6d6d;bottom:0;content:\" \";margin-left:5px;position:absolute;top:0;width:1px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/SiteFooter.vue"],"names":[],"mappings":"AACA,oBACE,eAAgB,AAChB,mBAAoB,AACpB,WAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB,AACD,mBACE,cAAkB,AAClB,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACpB,AACD,mBACE,cAAe,AACf,qBAAsB,AACtB,aAAe,CAChB,AACD,yBACE,aAAe,CAChB,AACD,8BACE,mBAAoB,AACpB,yFAA8F,AAC9F,kDAAoD,AACpD,UAAY,CACb,AACD,4BACE,mBAAoB,AACpB,WAAa,CACd,AACD,wCACE,YAAc,CACf,AACD,oBACE,eAAiB,CAClB,AACD,uBACI,qBAAsB,AACtB,SAAW,CACd,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,mEACE,mBAAoB,AACpB,SAAU,AACV,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,UAAW,AACX,eAAgB,AAChB,WAAa,CACd,AACD,sCACE,WAAY,AACZ,eAAgB,AAChB,WAAa,CACd,AACD,mCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,uCACI,YAAa,AACb,qBAAuB,CAC1B,AACD,2BACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,6BAA8B,AAC1B,uBAAwB,AACpB,mBAAoB,AAC5B,uBAAwB,AACpB,oBAAqB,AACjB,2BAA4B,AACpC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,6BACI,aAAe,CAClB,AACD,+BACI,YAAa,AACb,qBAAuB,CAC1B,AACD,mCACE,WAAY,AACZ,iBAAmB,CACpB,AACD,yCACE,WAAY,AACZ,YAAa,AACb,cAAe,AACf,SAAU,AACV,iBAAmB,CACpB,AACD,4EACE,mBAAoB,AACpB,SAAU,AACV,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ","file":"SiteFooter.vue","sourcesContent":["\nh3[data-v-a9ce9c7e] {\n  font-size: 18px;\n  font-family: Roboto;\n  color: #FFFFFF;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\np[data-v-a9ce9c7e] {\n  color: whitesmoke;\n  font-size: 16px;\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\na[data-v-a9ce9c7e] {\n  color: #d5e14d;\n  text-decoration: none;\n  display: block;\n}\na[data-v-a9ce9c7e]:hover {\n  color: #28a028;\n}\n.footer-item[data-v-a9ce9c7e] {\n  font-family: Roboto;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#5b5b5c), to(#131314));\n  background-image: linear-gradient(#5b5b5c, #131314);\n  width: 100%;\n}\n.footer-bg[data-v-a9ce9c7e] {\n  background: #f3f3f3;\n  height: auto;\n}\n.before-footer-content[data-v-a9ce9c7e] {\n  height: 150px;\n}\nul[data-v-a9ce9c7e] {\n  list-style: none;\n}\nul li[data-v-a9ce9c7e] {\n    display: inline-block;\n    width: 50%;\n}\n.vertical-divider[data-v-a9ce9c7e] {\n  clear: both;\n  position: relative;\n}\n.vertical-divider[data-v-a9ce9c7e]:after {\n  clear: both;\n  content: \" \";\n  display: block;\n  height: 0;\n  visibility: hidden;\n}\n.vertical-divider .column[data-v-a9ce9c7e]:not(:first-child):after {\n  background: #6d6d6d;\n  bottom: 0;\n  content: \" \";\n  margin-left: -10px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\nhr .divider[data-v-a9ce9c7e] {\n  background-color: #6d6d6d;\n}\n.divider-flex-rows[data-v-a9ce9c7e] {\n  width: 90%;\n  padding: 15px 0;\n  margin: auto;\n}\n.divider-layout-rows[data-v-a9ce9c7e] {\n  width: 100%;\n  padding: 15px 0;\n  margin: auto;\n}\n.footer-copyright[data-v-a9ce9c7e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.footer-copyright img[data-v-a9ce9c7e] {\n    height: 50px;\n    vertical-align: middle;\n}\n.site-map[data-v-a9ce9c7e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.site-map a[data-v-a9ce9c7e] {\n    margin: 0 15px;\n}\n.site-map img[data-v-a9ce9c7e] {\n    height: 50px;\n    vertical-align: middle;\n}\n.site-map-divider[data-v-a9ce9c7e] {\n  clear: both;\n  position: relative;\n}\n.site-map-divider[data-v-a9ce9c7e]:after {\n  clear: both;\n  content: \" \";\n  display: block;\n  height: 0;\n  visibility: hidden;\n}\n.site-map-divider .site-map-column[data-v-a9ce9c7e]:not(:first-child):after {\n  background: #6d6d6d;\n  bottom: 0;\n  content: \" \";\n  margin-left: 5px;\n  position: absolute;\n  top: 0;\n  width: 1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 874:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(872);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("71a8954f", content, true, {});

/***/ }),

/***/ 875:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(878),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a9ce9c7e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 878:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('v-layout', {
    staticClass: "before-footer-content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container')], 1), _vm._v(" "), _c('v-divider', {
    staticStyle: {
      "background-color": "#d5e14d"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("INDUSTRIES IN GEORGIA")]), _vm._v(" "), _c('v-flex', [_c('ul', {
    staticClass: "industry-item"
  }, _vm._l((_vm.industries), function(industry, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": industry.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(industry.name))])])
  }), 0)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "hidden-sm-down": ""
    }
  }, [_c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("COMPETITIVE ADVANTAGE")]), _vm._v(" "), _vm._l((_vm.competitiveAdvantages), function(advantage, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": advantage.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(advantage.name))])
  })], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("BUSINESS RESOURCES")]), _vm._v(" "), _vm._l((_vm.businessResources), function(resource, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": resource.link,
        "target": "blank"
      }
    }, [_vm._v(_vm._s(resource.name))])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "vertical-divider",
    attrs: {
      "md4": "",
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "social-media-footer column",
    attrs: {
      "md12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md-12": ""
    }
  }, [_c('h3', [_vm._v("CONNECT WITH US")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-email")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-facebook-box")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-youtube-play")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": "",
      "medium": ""
    }
  }, [_vm._v("mdi-rss")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-flex-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "contact-us column",
    attrs: {
      "md12": ""
    }
  }, [_c('h3', [_vm._v("CONTACT US")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.georgia.org/about-us/contact-us/"
    }
  }, [_vm._v("Use our Contact form")]), _vm._v(" "), _c('p', [_vm._v("Call us at +1-404-962-4000")]), _vm._v(" "), _c('p', [_vm._v("+1-800-255-0056 for the hearing impaired")]), _vm._v(" "), _c('p', [_vm._v("Georgia Department of Economic Development")]), _vm._v(" "), _c('p', [_vm._v("Technology Square, 75 5th Street N.W., Suite 1200 Atlanta, GA 30308")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "site-map site-map-divider",
    attrs: {
      "md12": ""
    }
  }, [_c('div', {
    staticClass: "site-map-column"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-we_speak_business.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.georgia.org/sitemap",
      "target": "blank"
    }
  }, [_vm._v("Site Map")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.exploregeorgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("ExploreGeorgia.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://www.gaarts.org/",
      "target": "blank"
    }
  }, [_vm._v("GaArts.org")])]), _vm._v(" "), _c('div', {
    staticClass: "site-map-column"
  }, [_c('a', {
    attrs: {
      "href": "http://siteselector.georgia.org/?_ga=2.117864841.1812343620.1523235297-576062532.1522934539",
      "target": "blank"
    }
  }, [_vm._v("GeorgiaSiteSelector")])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "divider-layout-rows",
    attrs: {
      "md12": ""
    }
  }, [_c('v-divider', {
    staticClass: "rows",
    staticStyle: {
      "background-color": "#6d6d6d"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "footer-copyright",
    attrs: {
      "md12": ""
    }
  }, [_c('p', [_vm._v("© " + _vm._s(_vm.year) + " Georgia Department of Economic Development. All Rights Reserved.")]), _vm._v(" "), _c('p', [_vm._v("GDEcD is an equal opportunity employer.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/footer-logo.png"
    }
  })])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 936:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ["dialog"],
  data: function data() {
    return {
      openModal: this.dialog,
      help: {
        topic: "Other",
        comment: ""
      },
      keys: {
        topics: ["Homepage", "Directory", "Opportunity", "History", "Chat", "Other"]
      }
    };
  },
  watch: {
    dialog: function dialog(val) {
      this.openModal = val;
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    }
  },
  methods: {
    cancel: function cancel() {
      this.openModal = false;
      this.$emit("cancel");
    },
    submitHelp: function submitHelp() {
      this.cancel();
      this.$store.dispatch("submitHelp", {
        help: this.help
      });
    }
  }
};

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".feedback .input-group.input-group--selection-controls label{left:25px;font-size:13px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/supportTicket.vue"],"names":[],"mappings":"AACA,6DACE,UAAW,AACX,cAAgB,CACjB","file":"supportTicket.vue","sourcesContent":["\n.feedback .input-group.input-group--selection-controls label {\n  left: 25px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(938);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("a3ade636", content, true, {});

/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 945:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": 700,
      "persistent": ""
    },
    model: {
      value: (_vm.openModal),
      callback: function($$v) {
        _vm.openModal = $$v
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitHelp()
      }
    }
  }, [_c('v-card-title', [_vm._v("\n        OPEN SUPPORT TICKET\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-card-text', [_c('b', [_vm._v("Support Topic:")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "feedback",
    staticStyle: {
      "font-size": "6px"
    },
    attrs: {
      "row": false,
      "column": false,
      "value": "Neutral"
    },
    model: {
      value: (_vm.help.topic),
      callback: function($$v) {
        _vm.$set(_vm.help, "topic", $$v)
      },
      expression: "help.topic"
    }
  }, _vm._l((_vm.keys.topics), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1), _vm._v(" "), _c('b', [_vm._v("Comment")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "hide-details": ""
    },
    model: {
      value: (_vm.help.comment),
      callback: function($$v) {
        _vm.$set(_vm.help, "comment", $$v)
      },
      expression: "help.comment"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "red darken-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 947:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_feedbackModal_vue__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_feedbackModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modal_feedbackModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_supportTicket_vue__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_supportTicket_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_modal_supportTicket_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = {
  props: ['module'],
  components: {
    FeedbackModal: __WEBPACK_IMPORTED_MODULE_0__components_modal_feedbackModal_vue___default.a,
    SupportModal: __WEBPACK_IMPORTED_MODULE_1__components_modal_supportTicket_vue___default.a
  },
  data: function data() {
    return {
      modalTrigger: false,
      supportTrigger: false,
      tourIds: {
        homepage: 'MixRJQmhQBH',
        directory: '9l9njEAufib',
        opportunities: 'WpbadE91hoh',
        history: 'GD0hCmzf0vy'
      }
    };
  },
  methods: {
    openModal: function openModal() {
      this.modalTrigger = true;
    },
    openSupport: function openSupport() {
      this.supportTrigger = true;
    },
    startTour: function startTour() {
      var HelpHero = window.HelpHero;
      HelpHero.startTour(this.tourIds[this.module]);
    }
  }
};

/***/ }),

/***/ 949:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ["dialog", "module"],
  data: function data() {
    return {
      openModal: this.dialog,
      feedback: {
        satisfaction: "Very Unsatisfied",
        usage: "Definitely not",
        recommendation: "Definitely not",
        frequency: "Once a week",
        suggestion: ""
      },
      keys: {
        statisfaction: ["Very Unsatisfied", "Unsatisfied", "Neutral", "Satisfied", "Very Satisfied"],
        usage: ["Definitely not", "Probably not", "Not sure", "Probably", "Definitely"],
        recommendation: ["Definitely not", "Probably not", "Not sure", "Probably", "Definitely"],
        frequency: ["Once a week", "2 - 3 times a month", "Once a month", "Less then once a month"]
      }
    };
  },
  watch: {
    dialog: function dialog(val) {
      this.openModal = val;
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    }
  },
  methods: {
    cancel: function cancel() {
      this.openModal = false;
      this.$emit("cancel");
    },
    submitFeedback: function submitFeedback() {
      this.cancel();
      this.$store.dispatch("submitFeedback", {
        feedback: this.feedback,
        module: this.module
      });
    }
  }
};

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"FeedbackComponent.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".feedback .input-group.input-group--selection-controls label{left:25px;font-size:13px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/feedbackModal.vue"],"names":[],"mappings":"AACA,6DACE,UAAW,AACX,cAAgB,CACjB","file":"feedbackModal.vue","sourcesContent":["\n.feedback .input-group.input-group--selection-controls label {\n  left: 25px;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 952:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(950);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("adb622b4", content, true, {});

/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(951);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("47cfe6d4", content, true, {});

/***/ }),

/***/ 954:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(947),
  /* template */
  __webpack_require__(957),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(949),
  /* template */
  __webpack_require__(958),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 957:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "feedback-component grey lighten-3 text-xs-center primary--text",
    staticStyle: {
      "position": "absolute",
      "right": "0px",
      "top": "50px",
      "height": "42px"
    }
  }, [_c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startTour()
      }
    }
  }, [_vm._v("\n          Start Tour\n          "), _c('v-icon', {
    staticClass: "primary--text pl-2"
  }, [_vm._v("flag")])], 1), _vm._v(" "), (['opportunities', 'history', 'directory'].includes(_vm.module)) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal()
      }
    }
  }, [_vm._v("\n          Send Feedback\n          "), _c('v-icon', {
    staticClass: "primary--text pl-2"
  }, [_vm._v("feedback")])], 1) : _vm._e(), _vm._v(" "), (['opportunities', 'history', 'directory'].includes(_vm.module)) ? _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openSupport()
      }
    }
  }, [_vm._v("\n        Help\n        "), _c('v-icon', {
    staticClass: "primary--text pl-2"
  }, [_vm._v("help")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('feedback-modal', {
    attrs: {
      "dialog": _vm.modalTrigger,
      "module": _vm.module
    },
    on: {
      "cancel": function($event) {
        _vm.modalTrigger = false
      }
    }
  }), _vm._v(" "), _c('support-modal', {
    attrs: {
      "dialog": _vm.supportTrigger
    },
    on: {
      "cancel": function($event) {
        _vm.supportTrigger = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 958:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": 700,
      "persistent": ""
    },
    model: {
      value: (_vm.openModal),
      callback: function($$v) {
        _vm.openModal = $$v
      },
      expression: "openModal"
    }
  }, [_c('v-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitFeedback()
      }
    }
  }, [_c('v-card-title', [_vm._v("\n        TELL US WHAT YOU THINK\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-card-text', [_c('b', [_vm._v("How statisfied are you wih this modal?")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "feedback",
    staticStyle: {
      "font-size": "6px"
    },
    attrs: {
      "row": false,
      "column": false,
      "value": "Neutral"
    },
    model: {
      value: (_vm.feedback.satisfaction),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "satisfaction", $$v)
      },
      expression: "feedback.satisfaction"
    }
  }, _vm._l((_vm.keys.statisfaction), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1), _vm._v(" "), _c('b', [_vm._v("Would you use this modal in the future?")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "feedback",
    staticStyle: {
      "font-size": "6px"
    },
    attrs: {
      "row": false,
      "column": false,
      "value": "Neutral"
    },
    model: {
      value: (_vm.feedback.usage),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "usage", $$v)
      },
      expression: "feedback.usage"
    }
  }, _vm._l((_vm.keys.usage), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1), _vm._v(" "), _c('b', [_vm._v("Would you recommend this module?")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "feedback",
    staticStyle: {
      "font-size": "6px"
    },
    attrs: {
      "row": false,
      "column": false,
      "value": "Neutral"
    },
    model: {
      value: (_vm.feedback.recommendation),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "recommendation", $$v)
      },
      expression: "feedback.recommendation"
    }
  }, _vm._l((_vm.keys.recommendation), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1), _vm._v(" "), _c('b', [_vm._v("How often do you use this module?")]), _vm._v(" "), _c('v-radio-group', {
    staticClass: "feedback",
    staticStyle: {
      "font-size": "6px"
    },
    attrs: {
      "row": false,
      "column": false,
      "value": "Neutral"
    },
    model: {
      value: (_vm.feedback.frequency),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "frequency", $$v)
      },
      expression: "feedback.frequency"
    }
  }, _vm._l((_vm.keys.frequency), function(n) {
    return _c('v-radio', {
      key: n,
      attrs: {
        "label": n,
        "value": n
      }
    })
  }), 1), _vm._v(" "), _c('b', [_vm._v("How can we improve this module?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "hide-details": ""
    },
    model: {
      value: (_vm.feedback.suggestion),
      callback: function($$v) {
        _vm.$set(_vm.feedback, "suggestion", $$v)
      },
      expression: "feedback.suggestion"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "red darken-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/22.01af777645594a1e414d.js